import qrcode from 'qrcode-generator'

export function getQrcode ({ text, correctLevel = 'L', typeNumber = 0, size = 110 }) {
  const qr = qrcode(typeNumber, correctLevel)
  qr.addData(text)
  qr.make()
  const cellSize = size / qr.getModuleCount()
  return qr.createDataURL(cellSize, 0)
}
